import React, { Component, createRef } from "react";
// // Editable
import { withTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { useParams } from "react-router-dom";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  addGraderAssignStockList,
  getUserByRoleId,
  updateGraderAssignStock,
  getUserApi,
  getShapes,
  getInclusion,
  updateGraderStock,
  updateGraderStockInWard,
  graderOutWardStocks,
  updateGraderOutWardStocks,
  updateTotalOutwardWeight,
} from "api";
import * as Yup from "yup";
import {
  categoriTypes,
  status,
  color,
  purity,
  process,
} from "../StaticData.js";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { number } from "prop-types";

class GraderDataEntryAssign extends Component {
  constructor(props) {
    const PendingStockList =
      props?.location?.query?.data?.stockGraderInWards.filter(
        x => x.stockDataEntryInWard.outwardDate == null
      );
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      isSubmit: false,
      isFirstSubmit: true,
      dataEntryPersonList: [],
      shapesList: [],
      inclusionList: [],
      totalOutwardWeight: props?.location?.query?.data?.graderOutWardStock?.totalOutwardWeight || 0,
      isOutWardExist: props?.location?.query?.data?.graderOutWardStock ? 1 : 0,
      props: props?.location?.query,
      acceptedStockList:
        props?.location?.query?.data?.stockGraderInWards.filter(
          x =>
            x.stockDataEntryInWard.outward_status !== "P" &&
            x.stockDataEntryInWard.outwardDate !== null
        ),
      notEditableRows:
        props?.location?.query?.isEdit == 1
          ? props?.location?.query?.data?.stockGraderInWards.map(x => x.id)
          : props?.location?.query?.data?.stockGraderInWards.map(x => x.id),
      stockList:
        props?.location?.query?.isEdit == 1
          ? PendingStockList.map(x => {
              return {
                id: x.id,
                ar: x.ar,
                graderStockId: x.graderStockId,
                weight: x.weight,
                weightType: x.weightType,
                outWardPieces: x.outWardPieces,
                outWardWeight: x.outWardWeight,
                shapeId: x.shapeId == null ? "" : x.shapeId,
                shape: x.shape.name,
                inclusionId: x.inclusionId == null ? "" : x.inclusionId,
                inclusion: x.inclusion,
                iColorId: x.iColorId == null ? "" : x.iColorId,
                oColorId: x.oColorId == null ? x.iColorId : x.oColorId,
                purityId: x.purityId == null ? "" : x.purityId,
                processId: "",
                remarks: x.remarks,
                nextRemarks: x.stockGraderOutWard
                  ? x.stockGraderOutWard.nextRemarks
                  : "",
                pieces: x.stockDataEntryInWard.pieces,
                srNo: x.stockDataEntryInWard.srNo,
                stockGraderOutWard: x.stockGraderOutWard,
              };
            })
          : PendingStockList.map(x => {
              return {
                id: x.id,
                ar: x.ar,
                graderStockId: x.graderStockId,
                weight: x.weight,
                weightType: x.weightType,
                outWardPieces: x.outWardPieces,
                outWardWeight: x.outWardWeight,
                shapeId: x.shapeId == null ? "" : x.shapeId,
                shape: x.shape.name,
                inclusionId: x.inclusionId == null ? "" : x.inclusionId,
                inclusion: x.inclusion,
                iColorId: x.iColorId == null ? "" : x.iColorId,
                oColorId: x.oColorId == null ? x.iColorId : x.oColorId,
                purityId: x.purityId == null ? "" : x.purityId,
                processId: "",
                remarks: x.remarks,
                nextRemarks: x.stockGraderOutWard
                  ? x.stockGraderOutWard.nextRemarks
                  : "",
                pieces: x.stockDataEntryInWard.pieces,
                srNo: x.stockDataEntryInWard.srNo,
                stockGraderOutWard: x.stockGraderOutWard,
              };
            }),
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  validateTable() {
    for (let i = 0; i < this.state.stockList.length; i++) {
      let e = this.state.stockList[i];
      if (
        e.shapeId == "" ||
        e.colorId == "" ||
        e.purityId == "" ||
        e.ar == ""
      ) {
        return false;
      }
    }
    return true;
  }
  async componentDidMount() {
    let factoryId = JSON.parse(localStorage.getItem("authUser")).factoryId;
    const shape = await getShapes();
    if (shape && shape.data) {
      this.setState({
        shapesList: [
          { label: "NONE", value: "" },
          ...shape.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
    }
    const inclusion = await getInclusion();
    if (inclusion && inclusion.data) {
      this.setState({
        inclusionList: [
          { label: "NONE", value: "" },
          ...inclusion.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
    }

    const dataEntry = await getUserApi({
      factoryId: factoryId ? factoryId : null,
      roleId: "ROLE0000001",
    });
    if (dataEntry && dataEntry.data) {
      this.setState({
        dataEntryPersonList: dataEntry.data.users,
      });
    }

    this.setState({
      stockList: this.state.stockList.map(x => {
        return {
          ...x,
          inclusionId:
            x.inclusionId == null
              ? []
              : this.state.inclusionList.filter(y =>
                  x.inclusionId.includes(y.value)
                ),
        };
      }),
    });
  }

  async updateOutwardWeight(values) {
    const jangadId = this.state.props.data.mainJangad.id;
    const mainJangadId = parseInt(jangadId.split('JANGAD')[1]);
    await updateTotalOutwardWeight({
      jangadId: mainJangadId,
      totalOutwardWeight: parseFloat(values.totalOutwardWeight)
    });
  }

  deleteRow(rowIndex) {
    this.state.stockList.splice(rowIndex, 1);
    this.setState({
      stockList: this.state.stockList,
      notEditableRows: this.state.stockList.map((x, index) => x.id),
    });
  }
  addRow() {
    this.setState({
      stockList: [
        ...this.state.stockList,
        {
          id: this.state.stockList.length + 1,
          categoryId: 1,
          weight: 0,
          weightType: "CT",
          pieces: 0,
          inWardRemarks: "",
          forNextPersonRemarks: "",
          status: "true",
          assignProcess: 0,
        },
      ],
      notEditableRows: [
        ...this.state.notEditableRows,
        this.state.stockList.length + 1,
      ],
    });
  }

  async handleSubmit(values) {
    if (this.state.props.isEdit == 1) {
      let id = this.state.props.data.id;
      let temp = {
        remarks: values.remarks,
        stockGraderInWards: this.state.stockList.map(x => {
          return { ...x, inclusionId: x.inclusionId.map(y => y.value) };
        }),
      };
      const data = await updateGraderStock({ id: id, data: temp });
    }
  }

  async assign(values) {
    let temp = {
      nextRemarks: values.nextRemarks,
      dataEntryUserId: values.dataEntryUserId,
      mainJangadId: this.state.props.data.mainJangadId,
      jangadId: this.state.props.data.jangadId,
      dataEntryStockId: this.state.props.data.dataEntryStockId,
      graderStockId: this.state.props.data.id,
      totalOutwardWeight: parseFloat(values.totalOutwardWeight),
      stockList: this.state.stockList,
    };
    const data = await graderOutWardStocks(temp);
    if (data.success == true) {
      this.setState({
        isFirstSubmit: false,
      });
    }
  }

  async update(values) {
    let temp = {
      remarks: values.remarks,
      nextRemarks: values.nextRemarks,
      dataEntryUserId: values.dataEntryUserId,
      mainJangadId: this.state.props.data.mainJangadId,
      jangadId: this.state.props.data.jangadId,
      dataEntryStockId: this.state.props.data.dataEntryStockId,
      graderStockId: this.state.props.data.id,
      totalOutwardWeight: parseFloat(values.totalOutwardWeight),
      stockGraderOutWards: this.state.stockList.map(x => {
        return { ...x, inclusionId: x.inclusionId.map(y => y.value) };
      }),
    };
    const data = await updateGraderOutWardStocks({
      data: temp,
      id: this.state.props.data.graderOutWardStock.id,
    });
    if (data.success == true) {
      this.setState({
        isFirstSubmit: false,
      });
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    document.title = "filler flow";

    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: "",
        hidden: true,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        sort: true,
        editable: false,
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        editable: false,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        editable: false,
      },
      {
        dataField: "weight",
        text: `${this.props.t("InWard Weight")}`,
        type: "number",
        footer: "",
        editable: false,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        editable: false,
      },

      {
        dataField: "iColorId",
        text: `${this.props.t("InWard Color")}`,
        editable: false,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: color,
        },
        formatter: (cell, row) => {
          return color.filter(x => x.value == cell)[0].label;
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      {
        dataField: "oColorId",
        text: `${this.props.t("OutWard Color")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: color,
        },
        formatter: (cell, row) => {
          return color.filter(x => x.value == cell)[0].label;
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      {
        dataField: "outWardWeight",
        text: `${this.props.t("OutWard Weight")}`,
        footer: columnData => {
          return (
            columnData
              .map(x => parseFloat(x))
              .reduce((acc, item) => acc + item, 0)
              .toFixed(2) + " CT"
          );
        },
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        validator: (newValue, row, column) =>
          validate(
            [{ name: "number" }],
            "outward weight",
            newValue,
            row,
            column
          ),
      },
      {
        dataField: "shapeId",
        text: `${this.props.t("Shapes")}`,
        editable: false,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.shapesList,
        },
        formatter: (cell, row) => {
          if (row.shape == "") {
            return "NONE";
          } else {
            // return this.state.shapesList?.filter(x => x.value == cell)[0]?.label;
            return row.shape;
          }
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      {
        dataField: "inclusionId",
        text: `${this.props.t("Inclusion")}`,
        footer: "",
        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          row.inclusionId = row.inclusionId.map(x => {
            return typeof x == "number"
              ? this.state.inclusionList.filter(x => x.value == x)[0]
              : x;
          });
          return (
            <div className="mb-3 select2-container">
              <Select
                value={row.inclusionId.map(x => {
                  return typeof x == "number"
                    ? this.state.inclusionList.filter(x => x.value == x)[0]
                    : x;
                })}
                isMulti={true}
                onChange={e => {
                  row.inclusionId = e;
                  this.setState({ selectedMulti: null });
                }}
                options={this.state.inclusionList}
              />
            </div>
          );
        },
        formatter: (cell, row) => {
          if (row.inclusionId.length && typeof row.inclusionId[0] != "number") {
            let temp = [];
            temp = row.inclusionId.map(x =>
              typeof x == "number" ? x : x.value
            );
            return this.state.inclusionList
              .filter(x => temp.includes(x.value))
              .map(x => (
                <span key={x.value} className="border border-1 px-1 py-1 m-1">
                  {x.label}
                </span>
              ));
          } else {
            return "NONE";
          }
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      {
        dataField: "purityId",
        text: `${this.props.t("Purity")}`,
        footer: "",
        editable: false,
        editor: {
          type: Type.SELECT,
          options: purity,
        },
        formatter: (cell, row) => {
          return purity.filter(x => x.value == cell)[0].label;
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },

      {
        dataField: "remarks",
        text: `${this.props.t("Inward Remarks")}`,
        footer: "",
        editable: false,
      },
      {
        dataField: "nextRemarks",
        text: `${this.props.t("For Next Person Instruction")}`,
        footer: "",
      },
      {
        dataField: "ar",
        text: `${this.props.t("Status")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: status,
        },
        editable: false,
        formatter: (cell, row) => {
          return cell == true || cell == "true" ? "Accept" : "Reject";
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
    ];
    const defaultSorted = [
      {
        dataField: "srNo",
        order: "asc",
      },
    ];

    document.title = "grader flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Assign Screen")} />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={
                  this.state.props.isEdit == 1
                    ? {
                        partyCode:
                          this.state.props.data.mainJangad.party.partyCode,
                        id: this.state.props.data.mainJangad.id,
                        name: this.state.props.data.mainJangad.name,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        cycle: this.state.props.data.jangad.cycle,
                        dataEntryUserId:
                          this.state.props.isEdit == 3
                            ? this.state.props.data?.graderOutWardStock
                                .dataEntryUser?.name
                            : this.state.props.data?.graderOutWardStock
                            ? this.state.props.data?.graderOutWardStock
                                .dataEntryUserId
                            : "",
                        remarks: this.state.props.data.graderOutWardStock
                          ? this.state.props.data.graderOutWardStock.nextRemarks
                          : "",
                        nextRemarks: this.state.props.data.graderOutWardStock
                          ? this.state.props.data.graderOutWardStock.nextRemarks
                          : "",
                        totalOutwardWeight: this.state.totalOutwardWeight,
                      }
                    : {
                        partyCode:
                          this.state.props.data.mainJangad.party.partyCode,
                        id: this.state.props.data.mainJangad.id,
                        name: this.state.props.data.mainJangad.name,
                        category:
                          this.state.props.data.mainJangad.category.name,
                        dataEntryUserId:
                          this.state.props.isEdit == 3
                            ? this.state.props.data?.graderOutWardStock
                                ?.dataEntryUser.name
                            : this.state.props.data?.graderOutWardStock
                            ? this.state.props.data?.graderOutWardStock
                                .dataEntryUserId
                            : "",
                        cycle: this.state.props.data.jangad.cycle,
                        remarks: this.state.props.data.graderOutWardStock
                          ? this.state.props.data.graderOutWardStock.nextRemarks
                          : "",
                        nextRemarks: this.state.props.data.graderOutWardStock
                          ? this.state.props.data.graderOutWardStock.nextRemarks
                          : "",
                        totalOutwardWeight: this.state.totalOutwardWeight,
                      }
                }
                validationSchema={Yup.object().shape({
                  id: Yup.string(),
                  partyCode: Yup.string().required("This value is required"),
                  dataEntryUserId: Yup.string().required(
                    "This value is required"
                  ),
                  remarks: Yup.string()
                    .max(512)
                    .min(1)
                    .max(255)
                    .nullable()
                    .notRequired(),
                  nextremarks: Yup.string()
                    .max(512)
                    .min(1)
                    .max(255)
                    .nullable()
                    .notRequired(),
                })}
              >
                {({
                  errors,
                  status,
                  touched,
                  values,
                  isValid,
                  isValidating,
                  isSubmitting,
                  validateOnMount,
                  validateForm,
                  validateField,
                }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                              {this.props.t("Assign Screen")}
                            </h4>
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Assign Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>

                        <CardBody>
                          <Row>
                            {/* <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Jangad No")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="id"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div> */}
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Jangad No")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="name"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Party Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.partyCode && touched.partyCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="partyCode"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="partyCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="category"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Diamond Category")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.category && touched.category
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.data ? true : false
                                  }
                                  type="text"
                                  name="category"
                                  placeholder="20.25 CT"
                                />
                                <ErrorMessage
                                  name="category"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            {this.state.props.isEdit != 3 ? (
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="dataEntryUserId"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Data Entry Person")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control form-select fs-5" +
                                      (errors.dataEntryUserId &&
                                      touched.dataEntryUserId
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.isEdit == 3
                                        ? true
                                        : false
                                    }
                                    name="dataEntryUserId"
                                    as="select"
                                  >
                                    <option value="">ALL</option>
                                    {this.state.dataEntryPersonList?.map(x => (
                                      <option value={x.id} key={x.id}>
                                        {x.name}
                                      </option>
                                    ))}
                                  </Field>
                                  <ErrorMessage
                                    name="dataEntryUserId"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            ) : (
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="dataEntryUserId"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Data Entry Person")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.dataEntryUserId &&
                                      touched.dataEntryUserId
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={true}
                                    type="text"
                                    name="dataEntryUserId"
                                    placeholder=""
                                  />
                                  <ErrorMessage
                                    name="dataEntryUserId"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            )}
                            <div className="mb-3 row">
                              <Label
                                htmlFor="cycle"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Cycle No.")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.cycle && touched.cycle
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={true}
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="cycle"
                                  placeholder="cycle 1"
                                />
                                <ErrorMessage
                                  name="cycle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="remarks"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Grader Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.remarks && touched.remarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  type="text"
                                  name="remarks"
                                  placeholder="Please Take of HPHT First Priority"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="remarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="nextRemarks"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Data Entry Outward Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.nextRemarks && touched.nextRemarks
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.isEdit == 3 ? true : false
                                  }
                                  type="text"
                                  name="nextRemarks"
                                  placeholder="Please Take of HPHT First Priority"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="nextRemarks"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="totalOutwardWeight"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Total Outward Weight")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.totalOutwardWeight && touched.totalOutwardWeight
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="totalOutwardWeight"
                                />
                                <ErrorMessage
                                  name="totalOutwardWeight"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                          </Row>
                        </CardBody>
                      </div>

                      <div className="row px-3 pt-3">
                        <div className="row px-3 pt-3">
                          <div className="d-flex justify-content-between">
                            <h3 className="fw-bold pb-3 text-black">
                              {this.props.t("Accepted stock Details")}
                            </h3>
                          </div>

                          <div className="table-responsive">
                            <table className="table border table-responsive background-light foo border-1">
                              <thead>
                                <tr>
                                  <th scope="col">{this.props.t("SR No.")}</th>
                                  <th scope="col">{this.props.t("Pieces")}</th>
                                  <th scope="col">
                                    {this.props.t("InWard Weight")}
                                  </th>

                                  <th scope="col">
                                    {this.props.t("InWard Color")}
                                  </th>
                                  <th scope="col">
                                    {this.props.t("OutWard Color")}
                                  </th>
                                  <th scope="col">
                                    {this.props.t("OutWard Weight")}
                                  </th>
                                  <th scope="col">{this.props.t("Shapes")}</th>

                                  <th scope="col">
                                    {this.props.t("Inclusion")}
                                  </th>

                                  <th scope="col">{this.props.t("Purity")}</th>
                                  <th scope="col">
                                    {this.props.t("Inward Remarks")}
                                  </th>
                                  <th scope="col">
                                    {this.props.t(
                                      "For Next Person Instructions"
                                    )}
                                  </th>
                                  <th scope="col">{this.props.t("Status")}</th>
                                </tr>
                              </thead>
                              {this.state.acceptedStockList.map((x, index) => (
                                <tbody key={index}>
                                  <tr>
                                    <td
                                      className="bg-success-green"
                                      scope="row"
                                    >
                                      {x.stockDataEntryInWard.srNo}
                                    </td>
                                    <td
                                      className="bg-success-green"
                                      scope="row"
                                    >
                                      {x.stockDataEntryInWard.pieces}
                                    </td>
                                    <td
                                      className="bg-success-green"
                                      scope="row"
                                    >
                                      {x.weight + " CT"}
                                    </td>
                                    <td className="bg-success-green">
                                      {color.filter(z => {
                                        return z.value == x.iColorId;
                                      }).length
                                        ? color.filter(z => {
                                            return z.value == x.iColorId;
                                          })[0].label
                                        : ""}
                                    </td>
                                    <td className="bg-success-green">
                                      {color.filter(z => {
                                        return z.value == x.oColorId;
                                      }).length
                                        ? color.filter(z => {
                                            return z.value == x.oColorId;
                                          })[0].label
                                        : ""}
                                    </td>
                                    <td className="bg-success-green">
                                      {x.outWardWeight}
                                    </td>
                                    <td
                                      className="bg-success-green"
                                      scope="row"
                                    >
                                      {x.shape.name}
                                    </td>
                                    <td
                                      className="bg-success-green"
                                      scope="row"
                                    >
                                      {x.inclusionId.length == 0 ? "None" : ""}
                                    </td>
                                    <td
                                      className="bg-success-green"
                                      scope="row"
                                    >
                                      {purity.filter(z => {
                                        return z.value == x.purityId;
                                      }).length
                                        ? purity.filter(z => {
                                            return z.value == x.purityId;
                                          })[0].label
                                        : ""}
                                    </td>

                                    <td className="bg-success-green">
                                      {x?.remarks || ""}
                                    </td>
                                    <td className="bg-success-green">
                                      {x?.nextRemarks || ""}
                                    </td>
                                    <td className="bg-success-green">
                                      {x.ar == true ? "Accept" : "Reject"}
                                    </td>
                                  </tr>
                                </tbody>
                              ))}
                            </table>
                          </div>
                        </div>
                        {this.state.props.isEdit != 3 && (
                          <>
                            <div className="d-flex justify-content-between">
                              <h3 className="fw-bold pb-3 text-black">
                                {this.props.t("Enter stock Details")}
                              </h3>
                              {/* <button
                              type="button"
                              className="bg-transparent border-0"
                              onClick={() => this.addRow()}
                            >
                              <img
                                src="images/dashboard-images/addRow.svg"
                                alt="add Row"
                              />
                            </button> */}
                            </div>
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField="id"
                                classes="foo"
                                headerClasses="background-light fs-5"
                                footerClasses="background-light fs-5"
                                data={this.state.stockList}
                                columns={this.columns1}
                                defaultSorted={defaultSorted}
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  // nonEditableRows: () => this.state.notEditableRows,
                                  afterSaveCell: () => {
                                    this.setState({
                                      stockList: [...this.state.stockList],
                                    });
                                  },
                                })}
                              />
                            </div>
                          </>
                        )}
                      </div>

                      {/* {this.state.isOutWardExist == 1 && (
                        <div className="px-3 pt-3">
                          <div className="">
                          <Formik
                            initialValues={
                              {
                                totalOutwardWeight: this.state.totalOutwardWeight
                              }
                            }
                          >
                            {(
                              {
                                values
                              }
                            ) => (
                              <Form>
                                <div className="d-flex">
                                  <Label
                                    htmlFor="totalOutwardWeight"
                                    className="col-form-label"
                                  >
                                    <h3 className="fw-bold pb-3 text-black" style={{ "margin-right": "10px" }}>
                                      {this.props.t("Total Outward Weight")}
                                    </h3>
                                  </Label>
                                  <div className="" style={{ "margin-right": "10px" }}>
                                    <Field
                                      className={
                                        "form-control fs-5"
                                      }
                                      type="text"
                                      name="totalOutwardWeight"
                                    />
                                  </div>
                                  <div>
                                    <Button
                                      color="primary"
                                      className="form-control fs-5"
                                      type="button"
                                      onClick={async () => {
                                        this.updateOutwardWeight(values);
                                        // await validateForm()
                                        //   .then(data => {
                                        //     if (Object.keys(data).length == 0) {
                                        //       this.update(values);
                                        //     }
                                        //   })
                                        //   .catch(err => console.log("err =>", err));
                                      }}
                                      // onClick={() => {
                                      //     this.updateOutwardWeight(this.state.totalOutwardWeight);
                                      // }}
                                    >
                                      Update
                                    </Button>
                                  </div>
                                </div>
                              </Form>
                            )}
                          </Formik>
                          </div>
                        </div>
                      )} */}

                      {this.state.props.isEdit == 3 && (
                        <>
                          <div className="row px-3 pt-4">
                            <div>
                              <h3 className="fw-bold pb-3 text-black">
                                {this.props.t("Stock summary")}
                              </h3>
                            </div>

                            <div className="table-responsive">
                              <BootstrapTable
                                classes="foo"
                                keyField="id"
                                headerClasses="background-light fs-5"
                                footerClasses="background-light fs-5"
                                bootstrap4={true}
                                defaultSorted={defaultSorted}
                                data={this.state.stockList}
                                columns={[...this.columns1].slice(0, -1)}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        {this.state.props.isEdit == 3 && (
                          <Button
                            color="primary"
                            className="fs-4 px-5 me-2"
                            type="submit"
                            onClick={() => this.state.history.goBack()}
                          >
                            Back
                          </Button>
                        )}

                        {this.state.props.isEdit == 1 && (
                          <>
                            <Button
                              color="primary"
                              className="fs-4 px-5 me-2"
                              onClick={() => {
                                this.props.history.goBack();
                              }}
                            >
                              Back
                            </Button>
                            {this.state.props.data.stockGraderInWards.filter(
                              x => {
                                return x.stockGraderOutWard == null;
                              }
                            ).length == 0 &&
                              this.state.isFirstSubmit &&
                              !this.state.props?.data?.graderOutWardStock
                                ?.dataEntryUser?.name && (
                                <Button
                                  color="primary"
                                  className="fs-4 px-5"
                                  type="submit"
                                  onClick={async () => {
                                    await validateForm()
                                      .then(data => {
                                        if (Object.keys(data).length == 0) {
                                          this.assign(values);
                                        }
                                      })
                                      .catch(err => console.log("err =>", err));
                                  }}
                                >
                                  Assign
                                </Button>
                              )}
                          </>
                        )}

                        {this.state.props.isEdit != 3 &&
                          this.state.props?.data?.graderOutWardStock
                            ?.dataEntryUser?.name && (
                            <>
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                                onClick={async () => {
                                  await validateForm()
                                    .then(data => {
                                      if (Object.keys(data).length == 0) {
                                        this.update(values);
                                      }
                                    })
                                    .catch(err => console.log("err =>", err));
                                }}
                              >
                                Update
                              </Button>
                            </>
                          )}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(GraderDataEntryAssign);
